/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

export interface ISplitData {
	$id: string;
}

export enum RenderType {
	Database = 'database',
	Edit = 'edit',
}

export class MockSplitData {
	public view: object = {};
	public localDataNotYetPersisted = false;

	protected database: object = {};
	protected edit: object = {};

	public primaryType: RenderType;
	public currentRenderType: RenderType;

	constructor(public $id: string, primaryType: RenderType = RenderType.Database) {
		this.primaryType = primaryType;
		this.currentRenderType = primaryType;
	}

	public databaseUpdate(payload: object) {
		this[this.primaryType] = payload;
		this.view = this[this.primaryType];
	}

	public localUpdate(payload: object) {
		this[this.currentRenderType] = Object.assign(this[this.currentRenderType], payload);
	}

	public switchView(renderType: RenderType, cancel: boolean = false) {
		if (this.currentRenderType === renderType) {
			return;
		}

		if (!cancel) {
			this[renderType as string] = Object.assign({}, this[this.currentRenderType]);
		}

		this[this.currentRenderType] = {};
		this.currentRenderType = renderType;
		this.view = this[this.currentRenderType];
	}
}
